import api from '../services/api';
import parseError from './error';

const withAbort = (fn) => {
  const controller = new AbortController();
  const promise = fn(controller.signal).catch((err) =>
    Promise.reject(parseError(err.response)),
  );
  return {
    promise,
    cancel: () => controller.abort(),
  };
};

export const getAlarms = ({ serialNumber, status, from, to } = {}) =>
  withAbort((signal) =>
    api
      .get('/alarms', {
        signal,
        params: { serialNumber, status, from, to },
      })
        .then((res) => res.data),
    );

export const getRecentAlerts = ({ limit } = {}) =>
  withAbort((signal) =>
    api
      .get('/alarms/recent', {
        signal,
        params: { limit },
      })
      .then((res) => res.data),
  );

const alarmsApi = { getAlarms, getRecentAlerts };
export default alarmsApi;
